module.exports = __webpack_public_path__ + "static/US2_modern_v2-e5991961badd43c3a3016f953b7a80c8.png";